module.exports = __webpack_public_path__ + "img/closePopup.c3b58d74.png";